module.exports = __webpack_public_path__ + "media/images/fake/007-d7c0439a5095ccea74e9e67cc2e990f6.jpg";